import { ErrorBoundaryWrapper } from '@/shared/ui';
import { Suspense } from 'react';
import { PublicProvider } from './providers/publicProvider/PublicProvider';
import AppRouter from './providers/router';

export default function App() {
  return (
    <ErrorBoundaryWrapper
      onReset={() => {
        window.location.reload();
      }}
    >
      <Suspense fallback="">
        <PublicProvider>
          <AppRouter />
        </PublicProvider>
      </Suspense>
    </ErrorBoundaryWrapper>
  );
}
